export default __webpack_public_path__ + "locales/zh-CN/Errors.json?hash=ddb799337eb44d4482372fdb0eb2dd91";